import { Link } from "react-router-dom";
import { LuView } from "react-icons/lu";
import AccountLayout from "./AccountLayout";
import { useRecentlyViewed } from "../libs/useRecentlyViewed";
import { getProductUrl } from "../libs/getProductUrl";
import { AccountGridSkeleton } from "./AccountSkeletons";
import ProductPriceDisplay from "../components/ProductPriceDisplay";
import "../components/ProductCard.css";
import "./UserProfile.css";

const PLACEHOLDER = "https://via.placeholder.com/200x200?text=No+Image";

const Recentview = () => {
  const { data: items = [], isLoading } = useRecentlyViewed();

  if (isLoading) {
    return (
      <AccountLayout loading>
        <AccountGridSkeleton count={6} />
      </AccountLayout>
    );
  }

  return (
    <AccountLayout title="Recently Viewed">
      {items.length === 0 && (
        <div className="account-empty">
          <div className="account-empty__icon">
            <LuView />
          </div>
          <h3>No recently viewed products</h3>
          <p>Products you browse will appear here for quick access.</p>
          <Link to="/market" className="account-btn account-btn--secondary">
            Browse marketplace
          </Link>
        </div>
      )}
      <div className="saved-products-grid">
        {items.map(({ product, _id }) =>
          product ? (
            <Link key={_id} to={getProductUrl(product)} className="saved-product-card">
              <img src={product.images?.[0] || PLACEHOLDER} alt={product.name} />
              <p>{product.name}</p>
              <ProductPriceDisplay product={product} size="card" />
            </Link>
          ) : null
        )}
      </div>
    </AccountLayout>
  );
};

export default Recentview;
